export default {
  list: {
    create: "Factuur",
    require: {
      invoiceNumber: "factuurnummer",
      country: 'land',
      currency: 'valuta',
      term: 'standaard facturatie termijn',
      tax: 'standaard BTW',
    },

    export: "Download facturen",
  },

  create: {
    saveAndReadyToSend: "en klaar voor versturen",
    cancel: "Annuleren",
  },

  edit: {
    delete: "Factuur",

    newVersion: "Maak nieuwe versie",
    invoiceDateToToday: "Factuur datum naar vandaag",

    require: {
      email: "e-mailadres",
      address: "adres",
      bankAccount: "bankrekening",
      businessNumbers: "bedrijfsnummers",
    },

    send: {
      email: {
        invoice: "Verstuur per e-mail",
        reminder: "Verstuur e-mail herinnering"
      },
    },

    print: {
      pdf: {
        download: "Download PDF",
        example: "Voorbeeld PDF",
      },
      require: {
        clientData: "Vul klantgegevens aan",
        printTemplate: "print template",
      },
    },

    makeCredit: "Maak credit factuur",

    status: {
      offer: "Offerte",
      draft: "Concept",
      readyToSend: "Klaar om te versturen",
      selfSend: "Print en verstuur",
      paid: "Betaald",
      irrecoverable: "Oninbaar",
    },
  },
}
